import $ from 'jquery';
import 'slick-carousel';
import SlickPlayPauseControls from './SlickPlayPauseControls';

const defaults = {
  fade: true,
  dots: false,
  autoplay: true,
  slide: '.views-row',
  autoplaySpeed: 6000,
};

function HeroCarousel(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.$slickContainer = this.addSlick();
  this.controls = this.addControls();
  this.preprocess();
  this.ready();
}

HeroCarousel.prototype = {
  preprocess() {
    this.$element.find('.node-header .title').each((i, title) => {
      const $title = $(title);
      const aTitle = $title.html().split('<br>');
      let html = '';
      $.each(aTitle, (a, text) => {
        html += `<span>${text}</span>`;
      });
      $title.html(html);
    });
  },
  addSlick() {
    return this.$element.find('.view-content').slick(this.settings);
  },
  ready() {
    this.$element.addClass('ready');
  },
  addControls() {
    return new SlickPlayPauseControls(this.$slickContainer, {
      attachTo: this.$element,
    });
  },
};

export default HeroCarousel;



// WEBPACK FOOTER //
// ./HeroCarousel.js